import { gql } from '@apollo/client'

// Types
export type EngineeringSchemaCreator = {
  accountId: number | null
  firstName: string | null
  lastName: string | null
}

export type EngineeringSchema = {
  id: string
  type: string
  namespace: string
  class: string
  producer: string | null
  data: Record<string, unknown> | null
  createdBy: EngineeringSchemaCreator | null
  createdTs: string | null
}

export type EngineeringSchemasResponse = {
  getEngineeringSchemas: {
    schemas: EngineeringSchema[]
    lastEvaluatedKey: string | null
  }
}

export type EngineeringSchemasVariables = {
  input: {
    filter?: {
      id?: string[]
      type?: string[]
      namespace?: string[]
      class?: string[]
      producer?: string[]
      createdBy?: number[]
      onlyLatest?: boolean
    }
    pagination?: {
      limit: number
      exclusiveStartKey?: string
    }
  }
}

export type EngineeringSchemasFilterOptionsResponse = {
  getEngineeringSchemasFilterOptions: {
    type: string[]
    namespace: string[]
    class: string[]
    producer: string[]
    createdBy: EngineeringSchemaCreator[]
  }
}

export type CreateEngineeringSchemaResponse = {
  createEngineeringSchema: EngineeringSchema
}

export type CreateEngineeringSchemaVariables = {
  input: {
    type: string
    namespace: string
    class: string
    producer?: string
    data: Record<string, unknown>
  }
}

// Queries
export const GET_ENGINEERING_SCHEMAS = gql`
  query getEngineeringSchemas($input: EngineeringSchemasInput!) {
    getEngineeringSchemas(input: $input) {
      schemas {
        id
        type
        namespace
        class
        producer
        createdBy {
          accountId
          firstName
          lastName
        }
        createdTs
      }
      lastEvaluatedKey
    }
  }
`

export const GET_ENGINEERING_SCHEMA_BY_ID = gql`
  query getEngineeringSchemaById($input: EngineeringSchemasInput!) {
    getEngineeringSchemas(input: $input) {
      schemas {
        id
        type
        namespace
        class
        producer
        data
        createdBy {
          accountId
          firstName
          lastName
        }
        createdTs
      }
    }
  }
`

export const GET_ENGINEERING_SCHEMAS_FILTER_OPTIONS = gql`
  query getEngineeringSchemasFilterOptions {
    getEngineeringSchemasFilterOptions {
      type
      namespace
      class
      producer
      createdBy {
        accountId
        firstName
        lastName
      }
    }
  }
`

// Mutations
export const CREATE_ENGINEERING_SCHEMA = gql`
  mutation createEngineeringSchema($input: CreateEngineeringSchemaInput!) {
    createEngineeringSchema(input: $input) {
      id
      type
      namespace
      class
      producer
      data
      createdBy {
        accountId
        firstName
        lastName
      }
      createdTs
    }
  }
`
